// display names for item opt_itemType values (inventory and marketplace headers)
export const itemTypeLabels = {
  'inventory': 'Game Items',
  'realworld': 'Real Items',
  'collectible': 'Collectibles',
  'lottery': 'Lottery Tickets',
  'prizepack': 'Prize Packs',
  'contribution': 'Contributions',
}
